import { Skeleton as MantineSkeleton } from '@mantine/core'
import { FunctionComponent } from 'react'
import { WithClassName } from '../types/utils'

type SkeletonProps = WithClassName & {
  bigger?: boolean
  width?: string
}

export const Skeleton: FunctionComponent<SkeletonProps> = ({ className, bigger, width }) => <MantineSkeleton className={className} width={width} height={bigger ? 24 : undefined} />
